export default __webpack_public_path__ + "static/media/logo.4a92c7b4.svg";